import { combineReducers } from '@reduxjs/toolkit';
import events from './eventsSlice';
import event from './eventSlice';

const reducer = combineReducers({
  events,
  event
});

export default reducer;
